import { useState } from 'react';
import { Row, Col } from 'antd';
import Departments from './Departments';
import PermissionTree from './PermissionTree';
import { RoleType } from './types';

function PermissionManagement() {
  const [selectedRoleInfo, setSelectedRoleInfo] = useState({} as RoleType);

  return (
    <Row gutter={[12, 0]}>
      <Col span={16}>
        <Departments setSelectedRoleInfo={setSelectedRoleInfo} />
      </Col>
      <Col span={8}>
        <PermissionTree selectedRoleInfo={selectedRoleInfo} />
      </Col>
    </Row>
  )
}

export default PermissionManagement;